import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { pedidoPosPath, type PedidoPosLocationState } from '../../config/routes';

const parsePositiveInt = (value: string | null): number | undefined => {
  if (!value) return undefined;
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : undefined;
};

const PedidoVentaAltaRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navState = location.state as PedidoPosLocationState | null;

  const target = pedidoPosPath({
    cotizacionId: parsePositiveInt(searchParams.get('cotizacionId')),
  });

  return (
    <Navigate
      replace
      to={target}
      state={navState?.ventaPendiente ? { ventaPendiente: navState.ventaPendiente } : undefined}
    />
  );
};

export default PedidoVentaAltaRedirect;
